import React from "react";
import { Box, Skeleton } from "@mui/material";

// Shared scroll area sizing — matches the actual Top Performers /
// Question Paper Timeline lists so the card height doesn't jump
// when content swaps in.
const scrollAreaSx = {
  maxHeight: 350,
  minHeight: 350,
  overflow: "hidden",
  pr: 1,
};

// Skeleton row that mirrors the Top Performers item:
// [Avatar] [Name]         [Test type / category]   [Score] [Medal]
const TopPerformerRowSkeleton = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      p: 1,
      mb: 1,
      borderRadius: 2,
    }}
  >
    {/* Avatar + Name (35% width to match real row) */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "35%" }}>
      <Skeleton variant="circular" width={24} height={24} />
      <Skeleton variant="text" width="70%" height={20} />
    </Box>
    {/* Test type + category (50%) */}
    <Box sx={{ width: "50%", display: "flex", flexDirection: "column", gap: 0.5 }}>
      <Skeleton variant="text" width="65%" height={18} />
      <Skeleton variant="text" width="45%" height={14} />
    </Box>
    {/* Score + medal (15%) */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 1,
        width: "15%",
      }}
    >
      <Skeleton variant="text" width={28} height={22} />
      <Skeleton variant="circular" width={26} height={26} />
    </Box>
  </Box>
);

export const TopPerformersSkeleton = ({ rows = 5 }) => (
  <Box sx={{ ...scrollAreaSx, display: "flex", flexDirection: "column" }}>
    {Array.from({ length: rows }).map((_, i) => (
      <TopPerformerRowSkeleton key={`tp-skel-${i}`} />
    ))}
  </Box>
);

// Skeleton row that mirrors a Question Paper Timeline entry:
// (dot) "A <test_type> question paper on <category> was created by ..."
const TimelineRowSkeleton = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-start",
      gap: 1.5,
      mb: 1.5,
      pb: 1,
      borderBottom: "1px solid #f2f2f2",
    }}
  >
    <Skeleton variant="circular" width={10} height={10} sx={{ mt: 0.8, flexShrink: 0 }} />
    <Box sx={{ flex: 1 }}>
      <Skeleton variant="text" width="95%" height={20} />
      <Skeleton variant="text" width="60%" height={20} />
    </Box>
  </Box>
);

export const TimelineSkeleton = ({ rows = 5 }) => (
  <Box
    component="ul"
    sx={{
      ...scrollAreaSx,
      listStyle: "none",
      pl: 0,
      m: 0,
      overflowY: "auto",
    }}
  >
    {Array.from({ length: rows }).map((_, i) => (
      <Box component="li" key={`tl-skel-${i}`} sx={{ listStyle: "none" }}>
        <TimelineRowSkeleton />
      </Box>
    ))}
  </Box>
);
